/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/virtualMachineOperationsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a VirtualMachineOperations. */
var VirtualMachineOperations = /** @class */function () {
  /**
   * Create a VirtualMachineOperations.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function VirtualMachineOperations(client) {
    this.client = client;
  }
  VirtualMachineOperations.prototype.list = function (options, callback) {
    return this.client.sendOperationRequest({
      options: options
    }, listOperationSpec, callback);
  };
  VirtualMachineOperations.prototype.get = function (region, virtualMachineId, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      virtualMachineId: virtualMachineId,
      options: options
    }, getOperationSpec, callback);
  };
  VirtualMachineOperations.prototype.start = function (region, virtualMachineId, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      virtualMachineId: virtualMachineId,
      options: options
    }, startOperationSpec, callback);
  };
  VirtualMachineOperations.prototype.stop = function (region, virtualMachineId, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      virtualMachineId: virtualMachineId,
      options: options
    }, stopOperationSpec, callback);
  };
  VirtualMachineOperations.prototype.reimage = function (region, virtualMachineId, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      virtualMachineId: virtualMachineId,
      options: options
    }, reimageOperationSpec, callback);
  };
  VirtualMachineOperations.prototype.redeploy = function (region, virtualMachineId, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      virtualMachineId: virtualMachineId,
      options: options
    }, redeployOperationSpec, callback);
  };
  VirtualMachineOperations.prototype.resetPassword = function (body, region, virtualMachineId, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      region: region,
      virtualMachineId: virtualMachineId,
      options: options
    }, resetPasswordOperationSpec, callback);
  };
  return VirtualMachineOperations;
}();
export { VirtualMachineOperations };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listOperationSpec = {
  httpMethod: "GET",
  path: "api/me/virtualMachines",
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VirtualMachine"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var getOperationSpec = {
  httpMethod: "GET",
  path: "{region}/api/subscriptions/{subscriptionId}/virtualMachines/{virtualMachineId}",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.virtualMachineId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.VirtualMachine
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var startOperationSpec = {
  httpMethod: "POST",
  path: "{region}/api/subscriptions/{subscriptionId}/virtualMachines/{virtualMachineId}/start",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.virtualMachineId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var stopOperationSpec = {
  httpMethod: "POST",
  path: "{region}/api/subscriptions/{subscriptionId}/virtualMachines/{virtualMachineId}/stop",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.virtualMachineId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var reimageOperationSpec = {
  httpMethod: "POST",
  path: "{region}/api/subscriptions/{subscriptionId}/virtualMachines/{virtualMachineId}/reimage",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.virtualMachineId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var redeployOperationSpec = {
  httpMethod: "POST",
  path: "{region}/api/subscriptions/{subscriptionId}/virtualMachines/{virtualMachineId}/redeploy",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.virtualMachineId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var resetPasswordOperationSpec = {
  httpMethod: "POST",
  path: "{region}/api/subscriptions/{subscriptionId}/virtualMachines/{virtualMachineId}/resetPassword",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.virtualMachineId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: __assign(__assign({}, Mappers.ResetPasswordBody), {
      required: true
    })
  },
  responses: {
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};